import React from 'react';

function SvgAnimatedIconArrowRight(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = React.useId();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
      <defs>
        <linearGradient
          id={`${iconUuid}_a`}
          x1="70.01"
          x2="29.54"
          y1="70.24"
          y2="29.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ec6508" />
          <stop offset="1" stopColor="#f3921c" />
        </linearGradient>
        <style>
          {`
            .animate:hover .line-cd1 {
              animation: line-cd1-spin 1500ms linear;
            }

            .animate:hover .line-cd2 {
              animation: line-cd2-spin 1500ms linear;
            }

            .animate:hover .line-cd3 {
              animation-name: line-cd3-spin;
              animation-duration: 1500ms;
              animation-timing-function: linear;
            }

            .line-cd1 { opacity: 1; transform-origin: 90px 46px; }
            .line-cd2 { opacity: 1; transform-origin: 90px 51px; }
            .line-cd3 { opacity: 0; }

            @keyframes line-cd1-spin {
              12.5% {
                transform: rotate(-45deg);
              }

              25% {
                transform: rotate(0);
                opacity: 1;
              }

              35% {
                transform: rotate(0);
                opacity: 1;
              }

              50% {
                transform: translateX(200px);
                opacity: 0;
              }

              60% {
                transform: translateX(-200px);
                opacity: 0;
              }

              100% {
                transform: translateX(0);
                opacity: 1;
              }
            }

            @keyframes line-cd2-spin {
              12.5% {
                transform: rotate(45deg);
              }

              25% {
                transform: rotate(0);
                opacity: 1;
              }

              35% {
                transform: rotate(0);
                opacity: 1;
              }

              50% {
                transform: translateX(200px);
                opacity: 0;
              }

              60% {
                transform: translateX(-200px);
                opacity: 0;
              }

              100% {
                transform: translateX(0);
                opacity: 1;
              }
            }

            @keyframes line-cd3-spin {
              0% {
                opacity: 0;
              }

              12.5% {
                opacity: 0;
              }

              13% {
                opacity: 1;
              }

              25% {
                opacity: 1;
                transform: translateX(0);
              }

              35% {
                opacity: 1;
                transform: translateX(0);
              }

              50% {
                transform: translateX(200px);
                opacity: 0;
              }

              100% {
                transform: translateX(0);
                opacity: 0;
              }
            }

            @media (prefers-reduced-motion: reduce) {
                .line-cd1,
                .line-cd2,
                .line-cd3 {
                    animation: none;
                }
            }`}
        </style>
      </defs>
      <path
        className="line-cd1"
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={6}
        d="M 87.27 49.25 L 52.65 14.52 L 87.27 49.25 Z"
      />
      <path
        className="line-cd2"
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={6}
        d="M 53.71 86.54 L 87.27 50.75 L 53.71 86.54 Z"
      />
      <path
        className="line-cd3"
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={5}
        d="M 87.27 50.75 L 87.27 49.25 L 10.05 49.25 L 10.05 50.75 L 87.27 50.75 Z"
      />
    </svg>
  );
}

export default SvgAnimatedIconArrowRight;
